<template>
  <div class="previous-zoom" v-show="showControl">
    <div class="custom-control-div">
      <i
        v-b-tooltip.hover.left
        :title="titles.previous"
        @click.stop.prevent="previousZoom()"
        class="icon-Zoom_previous"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'PreviousZoomControl',
  props: ['showControl'],
  mounted() {
    this.$parent.$mapPromise.then((m) => {
      m.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$el);
    });
  },
  methods: {
    previousZoom() {
      this.$emit('previousZoom');
    },
  },
  computed: {
    titles() {
      return {
        previous: this.$gettext('Etape précédente'),
      };
    },
  },
};
</script>
